export enum PaymentsStatisticsFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  startDate = 'startDate',
  endDate = 'endDate',
}
